import React from 'react';
import {
  Box,
  Paper,
  Checkbox,
} from '@mui/material';
import NumberRangeQuestion from '../../questions/numberRange/NumberRangeQuestion';
import {
  DigitalQuestion,
  QuestionTypeV2,
} from '../../../redux/types';
import MultiChoiceQuestion from '../../questions/multiChoice/MultiChoiceQuestion';
import SingleChoiceQuestion from '../../questions/singleChoice/SingleChoiceQuestion';
import StringQuestion from '../../questions/string/StringQuestion';
import RatioQuestion from '../../questions/ratio/RatioQuestion';
import ChoiceWithTextQuestion from '../../questions/choiceWithText/ChoiceWithTextQuestion';
import SingleChoiceWithTextQuestion from '../../questions/singleChoiceWithText/SingleChoiceWithTextQuestion';
import MultiChoiceWithTextQuestion from '../../questions/multiChoiceWithText/MultiChoiceWithTextQuestion';

export type DigitalQuestionExtended = DigitalQuestion & {
  selected?: boolean;
};

type Props = {
  questions: DigitalQuestionExtended[];
  onSelect: (qId: number, checked: boolean) => void;
};

const QuestionPreviewSelector: React.FC<Props> = ({
  questions,
  onSelect,
}: Props) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>, q: DigitalQuestionExtended,
  ) => {
    const { checked } = event.target;
    onSelect(q.id, checked);
  };

  return (
    <Box sx={{ p: '1.5rem' }}>
      {
        questions.map((q) => (
          <Box key={q.id}>
            <Paper variant="outlined" sx={{ p: '1.5rem', my: 3 }}>
              <Box display="flex" alignItems="center" gap={4}>
                <Checkbox
                  checked={q.selected || false}
                  onChange={(e) => handleChange(e, q)}
                  inputProps={{ 'aria-label': 'question-select' }}
                  disabled={
                    q.type === QuestionTypeV2.SingleChoice
                    || q.type === QuestionTypeV2.MultiChoice
                    || q.type === QuestionTypeV2.ChoiceWithText
                  }
                />
                <Box>
                  {
                    q.type === QuestionTypeV2.NumberRange && (
                      <NumberRangeQuestion
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.SingleChoice && (
                      <SingleChoiceQuestion
                        deprecated
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.MultiChoice && (
                      <MultiChoiceQuestion
                        deprecated
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.String && (
                      <StringQuestion
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.Ratio && (
                      <RatioQuestion
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.ChoiceWithText && (
                      <ChoiceWithTextQuestion
                        deprecated
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.SingleChoiceWithText && (
                      <SingleChoiceWithTextQuestion
                        mode="view"
                        question={q}
                      />
                    )
                  }
                  {
                    q.type === QuestionTypeV2.MultiChoiceWithText && (
                      <MultiChoiceWithTextQuestion
                        mode="view"
                        question={q}
                      />
                    )
                  }
                </Box>
              </Box>
            </Paper>
          </Box>
        ))
      }
    </Box>
  );
};

export default QuestionPreviewSelector;
